import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import en from "./locales/en/en.json"
import pt from "./locales/pt/pt.json"
import es from "./locales/es/es.json"

i18next.use(LanguageDetector).use(initReactI18next).init({
    resources: {
        pt: {
            translation: pt,
        },
        en: {
            translation: en,
        },
        es: {
            translation: es,
        },
    },
    lng: localStorage.getItem("lng") || "pt",
    fallbackLng: 'pt',
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
        escapeValue: false,
    },
})

export default i18next